<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <!-- CONTENT GOES HERE -->
        <div>
		<div class="content">

    <div *ngIf="showSuccessMessage"
        style="background-color: greenyellow;z-index:1000; position: fixed; padding: 10px; height: 40px; display: block; right: 30px; top: 70px;">
        {{'SHARED_CONN_MODULE.MESSAGES.SHOW_SUCCESS_MESSAGE' | translate }}
    </div>
    <div *ngIf="resendConnSuccessMessage"
        style="background-color: greenyellow;z-index:1000; position: fixed; padding: 10px; height: 40px; display: block; right: 30px; top: 70px;">
        {{'SHARED_CONN_MODULE.MESSAGES.RESEND_CONN_SUCCESS_MESSAGE' | translate }}
    </div>
    <div *ngIf="disconnectConSuccessMessage"
        style="background-color: greenyellow;z-index:1000; position: fixed; padding: 10px; height: 40px; display: block; right: 30px; top: 70px;">
        {{'SHARED_CONN_MODULE.MESSAGES.DISCONNECT_CONN_SUCCESS_MESSAGE' | translate }}
    </div>
    <mat-tab-group (selectedTabChange)="onTabChanged($event.index)">


        <mat-tab label="{{'SHARED_CONN_MODULE.LIST.SUPPLIER_TITLE' | translate }}">

            <ng-template matTabContent>
                <br>

                <div>
                    <mat-card class="card" *ngFor="let supplier of supplierList">

                        <mat-card-content>
                            <div style="display: flex;">
                                <div class="card-column">
                                    <div>

                                        <h3 class="h3">{{supplier.name}}</h3><br>
                                        <span
                                            *ngIf="supplier.ffc !=null && supplier.ffc!=''">{{'SHARED_CONN_MODULE.LIST.FFC_ID'|
                                            translate }}
                                            &nbsp;:{{supplier.ffc}}</span>&nbsp;
                                        <span
                                            *ngIf="supplier.higg !=null && supplier.higg!=''">{{'SHARED_CONN_MODULE.LIST.HIGG_ID'|
                                            translate }} &nbsp;:
                                            {{supplier.higg}}</span>&nbsp;
                                        <span
                                            *ngIf="supplier.brand !=null && supplier.brand!=''">{{'SHARED_CONN_MODULE.LIST.BRAND_ID'|
                                            translate }}&nbsp;:{{supplier.brand}}</span>&nbsp;
                                        <span
                                            *ngIf="supplier.oar !=null && supplier.oar!=''">{{'SHARED_CONN_MODULE.LIST.OAR_ID'|
                                            translate }}
                                            &nbsp;:{{supplier.oar}}</span>&nbsp;
                                        <br>
                                        <!-- <span>{{supplier.address}}</span>
                                        <span>{{supplier.contactNumber}}</span> -->
                                        <span>
                                            {{supplier.countryName}}
                                        </span><br>
                                        <span>
                                            {{supplier.phone}}
                                        </span><br>
                                        <span>
                                            {{supplier.email}}
                                        </span>

                                    </div>
                                </div>
                                <div class="card-column">
                                    <div *ngIf="supplier.connections.length >0">

                                        <h3>{{'SHARED_CONN_MODULE.LIST.CONNECTIONS_LB' | translate }}</h3><br>
                                        <table class="table table-striped tablefixed">
                                            <thead>
                                                <tr>
                                                    <th>{{'SHARED_CONN_MODULE.LIST.SHARED_WITH_LB' | translate }}</th>
                                                    <th>{{'SHARED_CONN_MODULE.LIST.STATUS_LB' | translate }}</th>
                                                    <th>{{'SHARED_CONN_MODULE.LIST.DATE_LB' | translate }}</th>
                                                    <th>{{'SHARED_CONN_MODULE.LIST.ACTIONBY_LB' | translate }}</th>
                                                    <th>{{'SHARED_CONN_MODULE.LIST.ACTION_LB' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr *ngFor="let connection of supplier.connections">
                                                    <td>{{connection.sharedWith}}</td>
                                                    <td><span
                                                            *ngIf="connection.status==1">{{ConnectionStatusEnum[connection.status]}}</span>
                                                        <span
                                                            *ngIf="connection.status==2">{{ConnectionStatusEnum[connection.status]}}</span>
                                                        <span
                                                            *ngIf="connection.status==3">{{ConnectionStatusEnum[connection.status]}}</span>
                                                        <span
                                                            *ngIf="connection.status==4">{{ConnectionStatusEnum[connection.status]}}</span>
                                                        <span
                                                            *ngIf="connection.status==5">{{ConnectionStatusEnum[connection.status]}}</span>
                                                    </td>
                                                    <td>{{connection.actionDate| date:'mediumDate'}}</td>
                                                    <td><small>{{connection.supplierFirstName}}</small></td>
                                                    <td>
                                                        <span
                                                            *ngIf="connection.status==1 || connection.status==3  || connection.status==5 ">
                                                            <a
                                                                (click)="openResendInvitationDialog(connection, supplier.name)">
                                                                {{'SHARED_CONN_MODULE.BUTTONS.RESEND' | translate
                                                                }}</a></span>
                                                        <span *ngIf="connection.status==2 || connection.status==4 "><a
                                                                (click)="openDisconnectDialog(connection, supplier.name)">
                                                                {{'SHARED_CONN_MODULE.BUTTONS.DISCONN_BTN' | translate
                                                                }}</a></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                    <div *ngIf="supplier.connections.length ==0">
                                        <h3>{{'SHARED_CONN_MODULE.LIST.CONNECTIONS_LB' | translate }}</h3><br>
                                        <strong><i>{{'SHARED_CONN_MODULE.LIST.NO_CONN' | translate }}</i> </strong>
                                    </div>
                                </div>

                            </div>

                        </mat-card-content>

                    </mat-card>

                </div>
                <div *ngIf="supplierList.length ==0">
                    <span class="h4">{{'SHARED_CONN_MODULE.LIST.NO_SUPPLIER' | translate }}</span>
                </div>
                <br>


            </ng-template>
        </mat-tab>
        <mat-tab label="{{'SHARED_CONN_MODULE.LIST.CONNECT_TO_BRAND_TITLE' | translate }}">

            <ng-template matTabContent>
                <br>
                <span>{{'SHARED_CONN_MODULE.LIST.SEARCH_BRAND_TITLE' | translate }}</span>&nbsp;
                <div id="search-brand" i18n="Connectivity Component Select Brand">


                    <input class="form-control" [matAutocomplete]="auto" (keyup)="searchBrand($event.target.value)"
                        [(ngModel)]="selectedBrandName"
                        placeholder="{{'SHARED_CONN_MODULE.LIST.SEARCH_BRAND_MSG' | translate }} ">

                    <mat-autocomplete #auto="matAutocomplete">

                        <mat-option *ngFor="let brand of suggestedBrandList | slice:0:50"
                            (click)="onSearchBrandSelect(brand)" [value]="brand.name">

                            <li><strong>{{brand.name}}</strong></li>
                            <li>{{brand.countryName}}</li>
                            <li *ngIf="brand.Higg !='' || brand.Oar !='' || brand.identification !=''">
                                <span *ngIf="brand.Higg !=''">
                                    {{'SHARED_CONN_MODULE.LIST.HIGG_ID' | translate }} :{{brand.higg}} </span>&nbsp;

                                <span *ngIf="brand.Oar !=''">{{'SHARED_CONN_MODULE.LIST.OAR_ID'| translate }}
                                    :{{brand.Oar}}</span>&nbsp;

                                <span *ngIf="brand.identification !=''"> {{'SHARED_CONN_MODULE.LIST.SUPPLIER'|
                                    translate }}:{{brand.identification}}</span>&nbsp;

                                <span *ngIf="brand.FFC !=''">
                                    {{'SHARED_CONN_MODULE.LIST.FFC_ID'| translate }}:{{brand.FFC}}</span>&nbsp;
                            </li>
                            <li *ngIf="brand.activity !=''">{{'SHARED_CONN_MODULE.LIST.FACTORY_TYPE'| translate
                                }}:{{brand.FFC}}: {{brand.activity}}</li>

                        </mat-option>

                        <mat-option></mat-option>

                    </mat-autocomplete>

                </div>


                <br>
                <br>
                <table class="table table-striped tablefixed">
                    <thead>
                        <tr>
                            <th><input type="checkbox" [(ngModel)]="selectAllCheckbox" (change)="selectAll($event)">
                                &nbsp;&nbsp;{{'SHARED_CONN_MODULE.LIST.CONNECT_TABLE_COL_LB' | translate }}</th>
                            <th>{{'SHARED_CONN_MODULE.LIST.SUPPLIER_TABLE_COL_LB' | translate }}</th>
                            <th>{{'SHARED_CONN_MODULE.LIST.COUNTRY_TABLE_COL_LB' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let supplier of noConnectedSuppliers">
                            <td><input [checked]="supplier.checked"
                                    (change)="onSupplierSelected(supplier, $event.target.checked)" type="checkbox">
                            </td>
                            <td>{{supplier.name}}&nbsp;
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <span *ngIf="supplier.ffc !=null && supplier.ffc!=''">
                                    {{'SHARED_CONN_MODULE.LIST.FFC_ID'| translate }}:
                                    &nbsp;:{{supplier.ffc}}</span>&nbsp;
                                <span *ngIf="supplier.higg !=null && supplier.higg!=''">
                                    {{'SHARED_CONN_MODULE.LIST.HIGG_ID' | translate }} : &nbsp;:
                                    {{supplier.higg}}</span>&nbsp;
                                <span
                                    *ngIf="supplier.brand !=null && supplier.brand!=''">{{'SHARED_CONN_MODULE.LIST.BRAND_ID'|
                                    translate }}&nbsp;:{{supplier.brand}}</span>&nbsp;
                                <span
                                    *ngIf="supplier.oar !=null && supplier.oar!=''">{{'SHARED_CONN_MODULE.LIST.OAR_ID'|
                                    translate }}
                                    &nbsp;:{{supplier.oar}}</span>&nbsp;
                            </td>
                            <td>{{supplier.country}}</td>
                        </tr>
                    </tbody>
                </table>

                <div style="text-align: end;">



                    <button class="btn btn-default" color="primary" [disabled]="selectedBrand==null"
                        (click)="sendConnectionInvitation()">
                        {{'SHARED_CONN_MODULE.LIST.SEND_CONN_REQ_BTN' | translate }}
                    </button>
                </div>
            </ng-template>
        </mat-tab>

    </mat-tab-group>

    <ngx-loading [show]="isLoading"></ngx-loading>
</div>
</div>
		</div>
		</div>
